import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateEmailTemplates = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translateEmailTemplates(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['email-templates']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateEmailTemplates;
